import React, { useEffect, useState } from "react";
import Header from "./Header";
import HeaderMentor from "./HeaderMentor";
import HeaderRecruiter from "./HeaderRecruiter";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { useSearchParams } from "react-router-dom";
import { setJourney } from "store/slices/auth";

/**
 * HeaderWrapper component
 * Renders the correct header based on journey (Redux or localStorage).
 * - 'mentor' => HeaderMentor
 * - 'recruiter' => HeaderRecruiter
 * - else => Header (learner)
 */
const HeaderWrapper: React.FC = () => {
  // try pathname first ?j=recruiter or ?j=mentor
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useAppDispatch();
  let stateJourney = useAppSelector((state) => state.auth.journey);
  const [currJourney, setCurrJourney] = useState("learner");

  // remove it from url and set it to localStorage
  useEffect(() => {
    let journey = searchParams.get("j");
    if (journey && (journey === "recruiter" || journey === "mentor" || journey === "learner")) {
      searchParams.delete("j");
      setSearchParams(searchParams);
      localStorage.setItem("j", journey);
      dispatch(setJourney(journey));
      setCurrJourney(journey);
    } else if (stateJourney && (stateJourney === "recruiter" || stateJourney === "mentor" || stateJourney === "learner")) {
      localStorage.setItem("j", stateJourney);
      setCurrJourney(stateJourney);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, stateJourney]);




  if (currJourney === "mentor") return <HeaderMentor />;
  if (currJourney === "recruiter") return <HeaderRecruiter />;
  return <Header />;
};

export default HeaderWrapper; 